import React from 'react';

const differentiatorCards = [
  {
    id: 'consultancy',
    title: 'Consultancy',
    description:
      'We will invest our time to understand your brand\'s needs and goals. We will guide you about your performance on different social media platforms and will make a new approach for the best results. We have proven and tested social media campaigns that can help you grow your business. Get consultancy from our social media marketing service in Karachi.',
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
        <path d="M6 8h4" />
        <path d="M6 12h8" />
      </svg>
    ),
    cornerSvg: (
      <svg width="110" height="110" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="cross-platform-corner-svg">
        <rect x="20" y="24" width="60" height="44" rx="6" stroke="#0f172a" strokeWidth="3" fill="#f8fafc" />
        <line x1="32" y1="80" x2="68" y2="80" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" />
        <line x1="50" y1="68" x2="50" y2="80" stroke="#0f172a" strokeWidth="3" />
        <path d="M30 40h20" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M30 50h38" stroke="#0f172a" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="68" cy="40" r="4" fill="#c40a0a" />
        <path d="M15 90L30 90L40 82L60 90L70 82L85 90" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'brand-management',
    title: 'Brand Management',
    description:
      'We are here to manage your brand online. We create and handle your social media pages to interact with your audience and get their feedback. Our team engages with your customers to build trust among them and increase your brand loyalty. Being the best social media marketing company, we have professional marketers who carry out the best process to market your brand online.',
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <circle cx="11" cy="11" r="3" stroke="#c40a0a" />
      </svg>
    ),
    cornerSvg: (
      <svg width="110" height="110" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="cross-platform-corner-svg">
        <circle cx="45" cy="45" r="24" stroke="#0f172a" strokeWidth="3" fill="#f8fafc" />
        <path d="M62 62L82 82" stroke="#c40a0a" strokeWidth="4" strokeLinecap="round" />
        <circle cx="45" cy="45" r="10" stroke="#c40a0a" strokeWidth="2.5" strokeDasharray="3 3" />
        <path d="M15 90L30 90L40 82L60 90L70 82L85 90" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    description:
      'It is important to know who is interested in your business if you want your social media campaign to truly succeed. Our team carefully monitors every social platform where your brand appears, giving you insight into who\'s talking about you, what they\'re saying, and how you can keep your brand at the center of the conversation. By monitoring these insights, we evolve campaigns accordingly to drive targeted results.',
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="14" width="4" height="7" rx="1" />
        <rect x="9" y="10" width="4" height="11" rx="1" />
        <rect x="16" y="6" width="4" height="15" rx="1" />
        <path d="M18 2l4 4m0 0l-4 4m4-4H10" stroke="#c40a0a" />
      </svg>
    ),
    cornerSvg: (
      <svg width="110" height="110" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="cross-platform-corner-svg">
        <rect x="20" y="54" width="12" height="26" rx="2" stroke="#0f172a" strokeWidth="3" fill="#f8fafc" />
        <rect x="40" y="38" width="12" height="42" rx="2" stroke="#0f172a" strokeWidth="3" fill="#f8fafc" />
        <rect x="60" y="22" width="12" height="58" rx="2" stroke="#c40a0a" strokeWidth="3" fill="rgba(196, 10, 10, 0.12)" />
        <path d="M54 20L66 8L78 20" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M66 9V26" stroke="#c40a0a" strokeWidth="3" strokeLinecap="round" />
        <path d="M15 90L30 90L40 82L60 90L70 82L85 90" stroke="#0f172a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
];

function SocialMediaDifferentiatorsSection() {
  return (
    <section className="cross-platform-seo-section">
      <div className="container">
        {/* Section Header */}
        <div className="cross-platform-seo-header">
          <h2 className="cross-platform-seo-title">
            Factors making us <span className="seo-red-title">different from others</span>
          </h2>
          <p className="cross-platform-seo-subtitle">
            We work day and night to work on every aspect to deliver the best social media management services.
          </p>
        </div>

        {/* 3 White Cards Grid on Black Background */}
        <div className="cross-platform-seo-grid">
          {differentiatorCards.map((card) => (
            <div key={card.id} className="cross-platform-card">
              <div className="cross-platform-card-icon">
                {card.icon}
              </div>

              <h3 className="cross-platform-card-title">
                {card.title}
              </h3>

              <p className="cross-platform-card-desc">
                {card.description}
              </p>

              {/* Corner Graphic Sticking on Hover */}
              <div className="cross-platform-corner-wrapper">
                {card.cornerSvg}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SocialMediaDifferentiatorsSection;
